// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiEditInferencer } from "@refinedev/inferencer/mui";

// export const ClientEdit: React.FC<IResourceComponentsProps> = () => {
//   return (
//     <MuiEditInferencer
//       fieldTransformer={(field: any) => {
//         if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//           return false;
//         }

//         return field;
//       }}
//     />
//   );
// };

import { Box, TextField } from "@mui/material";
import { useTranslation } from "@refinedev/core";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";

export const ClientEdit = () => {
  const { translate } = useTranslation();

  const {
    saveButtonProps,
    register,
    control,
    formState: { errors },
    setValue
  } = useForm();

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("name", {
            required: translate("this-field-is-required"),
          })}
          error={!!(errors as any)?.name}
          helperText={(errors as any)?.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label={translate("name")}
          name="name"
        />

        <TextField
          {...register("pseudo", {
            required: translate("this-field-is-required"),
          })}
          error={!!(errors as any)?.pseudo}
          helperText={(errors as any)?.pseudo?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label={translate("pseudo")}
          name="pseudo"
        />
        <TextField
          {...register("phone", {
            required: translate("this-field-is-required"),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.phone}
          helperText={(errors as any)?.phone?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label={translate("phone")}
          name="phone"
        />
        <TextField
          {...register("color", {
            required: translate("this-field-is-required"),
          })}
          error={!!(errors as any)?.color}
          helperText={(errors as any)?.color?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label={"Color"}
          name="Color"
          type="color"
          onChange={(e) =>
            setValue("color", e.target.value, {
              shouldDirty: true,
              shouldTouch: true,
              shouldValidate: true,
            })
          }
        />
        <TextField
          {...register("adresse", {
            required: translate("this-field-is-required"),
          })}
          error={!!(errors as any)?.adresse}
          helperText={(errors as any)?.adresse?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label={translate("adresse")}
          name="adresse"
        />
        {/*
                    DatePicker component is not included in "@refinedev/mui" package.
                    To use a <DatePicker> component, you can follow the official documentation for Material UI.

                    Docs: https://mui.com/x/react-date-pickers/date-picker/#basic-usage
                */}
        <TextField
          {...register("createdAt", {
            required: translate("this-field-is-required"),
          })}
          error={!!(errors as any)?.createdAt}
          helperText={(errors as any)?.createdAt?.message}
          margin="normal"
          fullWidth
          disabled
          InputLabelProps={{ shrink: true }}
          label="Created At"
          name="createdAt"
        />
      </Box>
    </Edit>
  );
};
